import React from "react";
import "./Made_For_Your_Everyday_Moves.css";

const Made_For_Your_Everyday_Moves = () => {
  return (
    <section className="mf-section">
      <div className="mf-card">
        <img
          src="/assets/images/eco_friendly/Group_image.png"
          alt="Group"
          className="mf-image"
        />
        <div className="container">
          <div className="mf-overlay"></div>

          <div className="mf-content">
            <div className="mf-logo-box">
              <img
                src="/assets/images/logo/Pm-Road-logo.jpg"
                alt="Logo"
                className="mf-logo"
              />
            </div>

            <div className="mf-text-box">
              <h2 className="mf-title">Made for Your Everyday Moves</h2>
              <p className="mf-text">
                Whether you're catching a ride or sending a package, PmRoad keeps it
                simple, safe, and fast. One app, countless possibilities always on,
                always reliable.
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Made_For_Your_Everyday_Moves;
